import { useCallback, useContext } from 'react';

import { TokenContext } from '@/Contexts/TokenContext';
import { ApplicationTemplateProps } from '@/models/ApplicationTemplate';
import { baseUrl } from '@/utils/constants';

import { useCustomFetch } from './useCustomFetch';

export default function useApplicationTemplate() {
  const { authResult } = useContext(TokenContext);
  const { customFetch } = useCustomFetch();

  const getApplicationTemplate = useCallback(
    async (applicationTemplateId: number): Promise<ApplicationTemplateProps> => {
      const appTemplateUrl = `${baseUrl}applicationtemplate/${applicationTemplateId}`;

      const response = await customFetch<ApplicationTemplateProps>(appTemplateUrl, {
        method: 'GET',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
          Authorization: `Bearer ${authResult.accessToken}`,
        },
      });

      return response;
    },
    [authResult, customFetch]
  );

  return { getApplicationTemplate };
}
